import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import EmptyMessage from '@/components/shared/EmptyMessage';
import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import useStaffKlassFilters from '@/data/hook/klass/useStaffKlassFilters';
import useInfiniteService from '@/data/hook/useInfiniteService';
import { klassesQueryKeys } from '@/data/services/querykeys';
import { ROUTES } from '@/utils/routes';
import UnitListSkeleton from './UnitListSkeleton';

export default function StaffDefaultKlassRedirect() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLessons.staff',
  });
  const filters = useStaffKlassFilters();

  const {
    results: [firstKlass],
    isInitialLoading,
  } = useInfiniteService({
    ...klassesQueryKeys.list(filters)._ctx.infinity,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  if (isInitialLoading) return <UnitListSkeleton />;

  if (!firstKlass) return <EmptyMessage text={t('selectCourseOrKlass')} />;

  return (
    <Navigate
      replace
      to={ROUTES.COURSES.INFO(firstKlass.coursePathSlug, firstKlass.id)}
    />
  );
}
